
import React from 'react';
import { Link } from 'react-router-dom';

class RepairBanner extends React.Component {
	render() {
		return ( 
            <div className="repair-container">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h2>Har din cykel brug for eftersyn eller reparation?</h2>
                            <p>Vi tilbyder professionel og hurtig cykelreparation på vores eget værksted. Eftersyn fra kun 279 kr.</p>
                            <Link to="/repairs" className="btn btn-primary btn-lg">Se Værksted &amp; Priser</Link>
                        </div>
                    </div>
                </div>
            </div>
		);
	}
}

export default RepairBanner;


// WEBPACK FOOTER //
// ./src/Components/RepairBanner.js